module.exports = __webpack_public_path__ + "img/shadow.23cbea15.png";